<template>
    <AppHeader />
    <CategoriesMobile :categories="menuCategories" v-show="mobileCategoriesVisible" />
    <MenuBar />
    <StaticContent :categories="menuCategories" :staticType="staticType" />
    <BottomFooter />
</template>
  
<script>
import AppHeader from "@/components/header/Header.vue";
import MenuBar from "@/components/menu-bar/MenuBar.vue";
import BottomFooter from "@/components/footer/Footer.vue";
import CategoriesMobile from "@/components/categories-mobile/CategoriesMobile.vue";
import StaticContent from "@/components/static/StaticContent.vue";
import Network from "@/scripts/networks.js";

export default {
    components: {
        StaticContent,
        AppHeader,
        MenuBar,
        BottomFooter,
        CategoriesMobile
    },
    props: ['staticType'],
    data() {
        return {
            mobileCategoriesVisible: false,
            menuCategories: [],
        };
    },
    methods: {
        async loadMenuCategories() {
            const jsonResponse = await Network.get(process.env.VUE_APP_API_BASE_URL + "categories/menu");
            this.menuCategories = jsonResponse["categories"];
        },
        onCategoriesClicked() {
            this.mobileCategoriesVisible = true;
        },
        onCategoriesCloseClicked() {
            this.mobileCategoriesVisible = false;
        },
        onCategorySelected() {
            this.mobileCategoriesVisible = false;
        },
    },
    beforeMount() {
        this.loadMenuCategories();
    },
};
</script>